import { render } from "./upOption.vue?vue&type=template&id=2a0d6fcb&scoped=true"
import script from "./upOption.vue?vue&type=script&lang=js"
export * from "./upOption.vue?vue&type=script&lang=js"

import "./upOption.vue?vue&type=style&index=0&id=2a0d6fcb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0d6fcb"]])

export default __exports__